import { useEffect } from 'react';
import { hideAllergies } from 'components/Profile/helper';
import GroupCard from './GroupCard';
import { MEDICAL_GROUPS } from './helper';

// Mounted only when the patient can pick records, so the global list loads just then.
const Groups = ({ records, onLoad, selected }) => {
  useEffect(() => {
    if (!records) onLoad();
  }, []);

  return (
    <div className="space-y-4">
      {MEDICAL_GROUPS.filter(({ name }) => !(hideAllergies() && name === 'allergies')).map((group) => (
        <GroupCard
          key={group.name}
          {...group}
          items={(records ?? selected)?.[group.name]?.data ?? []}
          loading={!records}
        />
      ))}
    </div>
  );
};

export default Groups;
